import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowRight2Icon = ({ color = 'currentColor', size = 14, ref, ...props }) => {
    return (_jsx("svg", { ...props, width: size, height: size, stroke: color, ref: ref, fill: "none", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M7 4L13 10L7 16", strokeWidth: "1.6" }) }));
};
//# sourceMappingURL=arrow-right2-icon.js.map